/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventlocationorlistingrequired4Inputs */

const en_eventlocationorlistingrequired4 = /** @type {(inputs: Eventlocationorlistingrequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a location or link a listing`)
};

const de_eventlocationorlistingrequired4 = /** @type {(inputs: Eventlocationorlistingrequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge einen Standort hinzu oder verknüpfe einen Ort`)
};

/**
* | output |
* | --- |
* | "Add a location or link a listing" |
*
* @param {Eventlocationorlistingrequired4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventlocationorlistingrequired4 = /** @type {((inputs?: Eventlocationorlistingrequired4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventlocationorlistingrequired4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventlocationorlistingrequired4(inputs)
	return de_eventlocationorlistingrequired4(inputs)
});
export { eventlocationorlistingrequired4 as "eventLocationOrListingRequired" }